import {
  Document,
  PDFViewer,
  Page as PDFPage,
  StyleSheet,
  Text as PDFText,
  View as PDFView,
  Font,
  Image as PDFImage
} from '@react-pdf/renderer';

Font.register({
  family: 'Roboto',
  fonts: [{ src: '/Roboto-Bold.ttf', fontWeight: 'bold' }]
});

const fullScreenStyles = {
  container: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    zIndex: 1000,
    backgroundColor: 'white'
  }
};

const styles = StyleSheet.create({
  page: {
    padding: '30px',
    fontFamily: 'Roboto',
    fontSize: 10
  },
  heading: {
    fontSize: 18,
    fontWeight: 'bold',
    textAlign: 'center',
    marginBottom: '20px',
    color: '#4A90E2'
  },
  subheading: {
    fontSize: 14,
    fontWeight: 'bold',
    textAlign: 'center',
    marginBottom: 15
  },
  sectionHeader: {
    fontSize: 12,
    fontWeight: 'bold',
    textAlign: 'left',
    marginTop: 7,
    color: '#333'
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 8
  },
  label: {
    fontWeight: 'bold',
    fontSize: 10,
    width: '45%',
    textAlign: 'right',
    color: '#333'
  },
  value: {
    fontSize: 10,
    width: '50%',
    textAlign: 'right',
    color: '#333'
  },
  divider: {
    borderBottom: '2px solid #4A90E2',
    margin: '15px 0'
  },
  smallText: {
    fontSize: 8,
    marginTop: 10,
    textAlign: 'center',
    color: '#999'
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    gap: 5,
    paddingBottom: '3px',
    borderBottom: '1px solid #4A90E2',
    paddingTop: '10px',
    paddingRight: '30px',
    paddingLeft: '30px',
    border:"1px solid black",
    borderRadius:"5px"
  },
  column: {
    width: '50%',
    display: 'flex',
    flexDirection: 'column',
    gap: 1
  },
  row2: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 10
  },
  textUnderlined: {
    fontSize: 14,
    textDecoration: 'underline',
    textDecorationColor: 'black',
    textDecorationThickness: 2,
    width: '100%',
    textAlign: 'center',
    marginBottom: 1
  },
  logo: {
    width: '50px',
    height: '50px',
    marginBottom: 10
  },
  footer: {
    marginTop: 20,
    fontSize: 8,
    textAlign: 'center',
    color: '#aaa'
  },
  table: {
    width: '100%',
    borderTop: '1px solid black',
    borderBottom: '1px solid black',
    marginTop: 15
  },
  tableHeader: {
    backgroundColor: '#4A90E2',
    color: 'white',
    fontSize: 12,
    fontWeight: 'bold',
    padding: '5px 10px',
    textAlign: 'center'
  },
  tableRow: {
    display: 'flex',
    flexDirection: 'row',
    borderBottom: '1px solid #ddd',
    padding: '5px 10px',
    justifyContent:"space-around"
  },
  tableCell: {
    fontSize: 10,
    width: '50%',
    textAlign: 'center',
    padding: '1px'
  }
});

const formatDate = (dateString) => {
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};

const Page = ({ style, children, ...props }) => (
  <PDFPage style={{ ...styles.page, ...style }} {...props}>
    {children}
  </PDFPage>
);

const View = ({ style, children, ...props }) => (
  <PDFView style={{ ...style }} {...props}>
    {children}
  </PDFView>
);

const Text = ({ style, content, ...props }) => (
  <PDFText style={{ ...styles.text, ...style }} {...props}>
    {content}
  </PDFText>
);

export const SalarySlipPdf = ({ data }) => {
  const { employee, salaryMonth, baseSalary, daAmount, hraAmount, overtimeAmount, taAmount, pfAmount, esiAmount, deductions, grossSalary, netSalary, dueAmount } = data;
  const employeeName = `${employee?.personalInfo?.firstName} ${employee.personalInfo?.lastName}`;
  const employeeId = employee.workDetails.employeeId;

  return (
    <div style={fullScreenStyles.container}>
      <PDFViewer width="100%" height="100%" showToolbar>
        <Document title={`${employeeName} Salary Slip`}>
          <PDFPage size="A4" style={styles.page}>
             <PDFImage
                      src="/logo_Hospital_m.jpeg"
                      style={{ width: '100%', height: '80px', marginBottom: 1, marginRight: '10%' }}
                    />
            <Text content="Salary Slip" style={styles.textUnderlined} />

            {/* Employee Details Section */}
            <Text style={styles.sectionHeader}>Employee Details</Text>
            <View style={styles.contentContainer}>
              <View style={styles.column}>
                <View style={styles.row2}>
                  <Text content="Employee Name:" style={styles.label} />
                  <Text content={employeeName} style={styles.value} />
                </View>
                <View style={styles.row2}>
                  <Text content="Employee ID:" style={styles.label} />
                  <Text content={employeeId} style={styles.value} />
                </View>
                <View style={styles.row2}>
                  <Text content="Designation:" style={styles.label} />
                  <Text content={data?.employee?.workDetails?.role?.name} style={styles.value} />
                </View>
              </View>
              <View style={styles.column}>
                <View style={styles.row2}>
                  <Text content="DOB:" style={styles.label} />
                  <Text content={formatDate(data?.employee?.personalInfo?.dob)} style={styles.value} />
                </View>
                <View style={styles.row2}>
                  <Text content="Aadhar Number:" style={styles.label} />
                  <Text content={data?.employee?.documents?.aadharNumber} style={styles.value} />
                </View>
                <View style={styles.row2}>
                  <Text content="Salary Month:" style={styles.label} />
                  <Text content={formatDate(salaryMonth)} style={styles.value} />
                </View>
              </View>
            </View>

            {/* <View style={styles.divider} /> */}

            {/* Salary Breakdown Section */}
            <Text style={styles.sectionHeader}>Salary Breakdown</Text>

            {/* Earnings & Deductions Table */}
            <View style={styles.table}>
              <View style={styles.tableRow}>
                <Text style={[styles.tableCell, styles.tableHeader]} content="Earnings" />
                <Text style={[styles.tableCell, styles.tableHeader, { marginLeft: '30%' }]} content="Deductions" />
              </View>

              {/* Earnings Column */}
              <View style={styles.tableRow}>
                <Text style={styles.tableCell} content={`Base Salary: ₹${baseSalary}`} />
                <Text style={styles.tableCell} content={`PF: ₹${pfAmount}`} />
              </View>
              <View style={styles.tableRow}>
                <Text style={styles.tableCell} content={`DA: ₹${daAmount}`} />
                <Text style={styles.tableCell} content={`ESI: ₹${esiAmount}`} />
              </View>
              <View style={styles.tableRow}>
                <Text style={styles.tableCell} content={`HRA: ₹${hraAmount}`} />
                <Text style={styles.tableCell} content={`Deductions: ₹${deductions}`} />
              </View>
              <View style={{...styles.tableRow,width:"50%"}}>
                <Text style={styles.tableCell} content={`Overtime: ₹${overtimeAmount}`} />
              </View>
              <View style={{...styles.tableRow,width:"50%"}}>
                <Text style={styles.tableCell} content={`TA: ₹${taAmount}`} />
              </View>
            </View>

            {/* Net Salary Section */}
            <Text style={styles.sectionHeader}>Net Salary</Text>
            <View style={styles.row2}>
              <Text content="Net Salary:" style={styles.label} />
              <Text content={`₹${netSalary}`} style={styles.value} />
            </View>
            <View style={styles.row2}>
              <Text content="Due Amount:" style={styles.label} />
              <Text content={`₹${dueAmount}`} style={styles.value} />
            </View>
          </PDFPage>
        </Document>
      </PDFViewer>
    </div>
  );
};
